import routerOptions0 from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "D:/APM_Setup/nuxt/nuxt3-admin-myfirstguide/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}